import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createAddDocApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { initialAdditionalDocApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import {
  setStepApplicantEdited,
  setRequestIdentifier,
  completeApplicantStep,
} from "../../../../../../store/redux/slice/Forms/seAdditionalDocForm";
import AdditionalDocApplicantDetailsForm from "../../../common/form/applicant/AdditionalDocApplicantDetailsForm";
import { ApplicationSubtype } from "@duosoftbg/nacid-components";

const SeAdditionalDocStepApplicant = () => {
  const seAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.SeAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    seAdditionalDocForm,
    baseEndpointPaths.seAdditionalDoc,
    createAddDocApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialAdditionalDocApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset("SECONDARY_ADDITIONAL_DOCUMENTS", seAdditionalDocForm.applicantDetails, methods.reset);

  return (
    <AdditionalDocApplicantDetailsForm
      methods={methods}
      onSubmit={onSubmit}
      hasRepresentativeCompany={true}
      showPreviousSubmittedApplications={true}
      applicationSubtype={ApplicationSubtype.SECONDARY_ADDITIONAL_DOCUMENTS}
    />
  );
};
export default SeAdditionalDocStepApplicant;
